import {Navigate, Outlet, useParams} from 'react-router-dom'

import {useGetNotifications} from 'common/api'
import {Paper, Back, TabsPanel, Loader} from 'common/components'
import {useGetRequest, isMilestonePassed, REQUEST_APPROVED_STATUSES} from '.'

export default function Request() {
  const params = useParams()
  const {data: notifications} = useGetNotifications()
  const {data: request} = useGetRequest(params.uuid)

  if (request?.status === 'opened')
    return <Navigate replace to={`/projects/${request.project?.uuid}`} />

  const isChatUpdates = request
    ? notifications?.some(
        (notification: any) =>
          notification.data.project.uuid === request?.project?.uuid &&
          notification.type === 'newChatMessage'
      )
    : false

  const backTo = `/requests`
  const backState = {
    filterKey:
      request?.status === 'declined' ? 'declined' :
      REQUEST_APPROVED_STATUSES.includes(request?.status) ? 'approved' :
      'current'
  }

  const currentTabs =
    request && isMilestonePassed('forecast-created', request)
      ? [tabs[0], {key: 'schedule', label: 'Schedule'}, tabs[1]]
      : tabs

  return (
    <Paper relative fullHeight>
      <Back to={backTo} state={backState} />
      {request ? (
        <div>
          <TabsPanel
            isChatUpdates={isChatUpdates}
            title={request.project?.title || ''}
            img={request.project?.image || ''}
            path={`requests/loan/${request.uuid}`}
            tabs={currentTabs}
          />
          <Outlet />
        </div>
      ) : (
        <Loader />
      )}
    </Paper>
  )
}

const tabs = [
  {key: '', label: 'About'},
  {
    key: 'documents',
    label: 'Documents',
  },
]
